<template>
  <div class="media airport-option" data-cy="autocomplete-dropdown-item">
    <div class="media-left">
      <b-icon v-if="allAirports" icon="earth"></b-icon>
      <b-icon v-else icon="airplane"></b-icon>
    </div>
    <div class="media-content">
      <span class="airport-option__title">{{ title }}</span>
      <small class="airport-option__meta">
        <template v-if="allAirports">
          {{ location.city }}, {{ location.country }}
        </template>
        <template v-else>
          <strong class="airport-option__code">{{ location.airportCode }}</strong>
          <span> · {{ location.city }}, {{ location.country }}</span>
        </template>
      </small>
    </div>
  </div>
</template>

<script>
import { formatAirportTitle, isAllAirports } from "@/utils/airportSearch";

export default {
  name: "AirportOption",
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  computed: {
    allAirports() {
      return isAllAirports(this.location);
    },
    title() {
      return formatAirportTitle(this.location);
    }
  }
};
</script>

<style lang="scss" scoped>
.airport-option {
  align-items: flex-start;
}

.media-content {
  overflow: visible;
  white-space: normal;
}

.airport-option__title {
  display: block;
  color: #30384a;
  font-weight: 400;
  line-height: 1.3;
  white-space: normal;
}

.airport-option__meta {
  display: block;
  margin-top: 2px;
  color: #7a7a7a;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.3;
  white-space: normal;
}

.airport-option__code {
  color: #30384a;
  font-weight: 700;
}
</style>

<style lang="scss">
.autocomplete .dropdown-item {
  white-space: normal;
}

.autocomplete .dropdown-item .airport-option .media-content {
  overflow: visible;
  white-space: normal;
}
</style>
